import React from 'react';
import { Redirect } from 'react-router-dom';
import { generatePath } from 'react-router-dom/cjs/react-router-dom.min';
import { QUEST_CONTENT_MAX_SIZE } from '../../../data/constants/quests';
import { isValidAttachment } from '../../../data/filters/attachmentsFilters';
import { isQuestionCategoryPostable } from '../../../data/filters/questions/isQuestionCategoryPostable';
import { useEvent } from '../../../data/hooks/eventHooks';
import resolvePath from '../../../misc/resolvePath';
import { dialogAlert, dialogConfirm } from '../../elements/Dialog/dialogs';
import EditableAttachmentsList from '../../elements/EditableAttachmentsList/EditableAttachmentsList';
import Scrollable from '../../elements/Scrollable';
import ToolbarLayout from '../../elements/ToolbarLayout';
import ToolbarButton from '../../elements/ToolbarButtons/ToolbarButton';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import EventAttachment from '../EventAttachments/EventAttachment';
import Screen from '../Screen';
import CategoriesTabs from './common/CategoriesTabs';
import connectQuests from './common/connectQuests';
import PostContentToolbar from './common/PostContentToolbar/PostContentToolbar';
import RelativeRedirect from '../../elements/RelativeRedirect/RelativeRedirect';

export class EventQuestsPostQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question: props.question ? props.question.content || '' : '',
            isBusy: true,
            addAttachments: [],
            attachments: _(props).get('question.attachments', []),
            previewAttachment: null,
            hideAttachments: false,
        };
    }
    componentDidMount() {
        this.state.mounted = true;
        if (!this.props.question && this.el) {
            this.el.querySelector('textarea').focus();
        }
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        if (this.state.previewAttachment) {
            return (
                <EventAttachment
                    {...this.props}
                    attachment={this.state.previewAttachment}
                    allowDelete={!this.props.question}
                    onReturnClick={this.handleCloseAttachmentPreview.bind(this)}
                    onDelete={this.handleDeleteAttachment.bind(this, this.state.previewAttachment)}
                />
            );
        }

        let { i18n, event } = this.props,
            header = (
                <div className="header">
                    <TopBarEvent event={event} returnURL="..">
                        {this.props.question ? ' ' : i18n['label.post.quest']}
                    </TopBarEvent>
                    <ToolbarLayout>
                        <CategoriesTabs
                            {...this.props}
                            allTabName={i18n['label.general']}
                            hideMineTab={true}
                            catLink={(catId) => {
                                return _.compact(['/events', event.id, 'qa', catId || 'all', 'create']).join('/');
                            }}
                        />
                        {this.props.subscribableCategories.length ? <ToolbarButton src="img/ellipsis-horizontal.png" key="more" href="./categories" /> : null}
                    </ToolbarLayout>
                    {this.props.category.id ? (
                        <div className="whitebg content text main" style={{ fontSize: '110%' }}>
                            {this.props.category.description}
                        </div>
                    ) : (
                        <div className="whitebg content text main" style={{ fontSize: '110%' }}>
                            {i18n['message.startnetworking.quests']}
                        </div>
                    )}
                    <hr />
                </div>
            ),
            footer = (
                <div>
                    <PostContentToolbar
                        color={event.settings.primary_color}
                        disableSubmit={this.state.busy}
                        photoUploadEnabled={this.props.photoUploadEnabled}
                        videoUploadEnabled={this.props.videoUploadEnabled}
                        onFilesSelected={this.handleFilesSelected.bind(this)}
                        allowDelete={this.props.question && !this.props.question.answers.count}
                        onDelete={this.handleDeleteQuestion.bind(this)}
                    />
                    <EditableAttachmentsList
                        className={this.state.hideAttachments ? 'hideOnSmallScreens' : ''}
                        attachments={[...this.state.attachments, ...this.state.addAttachments]}
                        photoUploadEnabled={this.props.photoUploadEnabled}
                        videoUploadEnabled={this.props.videoUploadEnabled}
                        onClick={this.handleQuestionAttachmentClicked.bind(this)}
                        onDelete={this.handleDeleteAttachment.bind(this)}
                    />
                </div>
            ),
            rows = (this.state.question.match(/\n/) || []).length + 1;

        if (rows < 5) rows = 5;

        return (
            <form onSubmit={this.handleSubmit.bind(this)}>
                <Screen header={header} footer={footer}>
                    <Scrollable>
                        <div ref={(el) => (this.el = el)} className="content fill-container graybg">
                            <textarea
                                className="fill-container form-control"
                                value={this.state.question}
                                maxLength={QUEST_CONTENT_MAX_SIZE}
                                onChange={this.handleQuestionChange.bind(this)}
                                onFocus={this.handleTextareaFocusChange.bind(this, true)}
                                onBlur={this.handleTextareaFocusChange.bind(this, false)}
                            />
                        </div>
                    </Scrollable>
                </Screen>
            </form>
        );
    }
    async handleDeleteQuestion() {
        let { i18n } = this.props;

        if (await dialogConfirm(i18n['delete.quest'])) {
            // NOTE: no redirection done after promise since HasData components will redirect to the next valid path
            app.api.questions.deleteQuestion(this.props.event.id, this.props.question.id).catch(async (err) => {
                console.warn(err);
                await dialogAlert(message.networkerror);
            });
        }
    }
    handleTextareaFocusChange(textareaIsFocused) {
        this.setState({ hideAttachments: textareaIsFocused });
    }
    handleQuestionChange(event) {
        this.setState({ question: event.target.value });
    }
    handleDeleteAttachment(attachment) {
        this.setState({
            previewAttachment: null,
            addAttachments: this.state.addAttachments.filter((obj) => obj != attachment),
            attachments: this.state.attachments.filter((obj) => obj != attachment),
            removeAttachments: this.state.attachments.find((obj) => obj == attachment) ? [...this.state.attachments, attachment] : this.state.atatchments,
        });
    }
    handleCloseAttachmentPreview() {
        this.setState({ previewAttachment: null });
    }
    handleQuestionAttachmentClicked(attachment) {
        this.setState({ previewAttachment: attachment });
    }
    handleFilesSelected(files) {
        files = Array.from(files);
        let sizeLimit = this.props.event.video_file_limit * 1000 * 1000;
        this.setState({
            addAttachments: [...this.state.addAttachments, ...files.filter((file) => file.size < sizeLimit)],
        });
    }
    async handleSubmit(e) {
        e.preventDefault();

        let question = this.state.question.trim(),
            anonymous = false; //this.refs.anon.checked;

        if (!question.length) {
            return await dialogAlert(this.props.i18n['message.question_quality_warning']);
        } else {
            this.setState({ busy: true });
            app.store.dispatch(app.actions.ui.busy());

            let categoryId;
            if (this.props.category.id) {
                categoryId = this.props.category.id;
            }

            const newAttachments = this.state.addAttachments.filter((attachment) =>
                isValidAttachment(attachment.type || attachment.mimetype, this.props.photoUploadEnabled, this.props.videoUploadEnabled)
            );

            Promise.all(newAttachments.map((file) => app.api.events.uploadUserEventFile(this.props.eventId, file)))
                .then((newAttachments) => newAttachments.filter((i) => i))
                .then((newAttachments) => this.submitQuestion(question, anonymous, categoryId, [...this.state.attachments.map((attachment) => attachment.uid), ...newAttachments]))
                .then(() => {
                    app.history.push(resolvePath(app.history.location.pathname, '..'));
                })
                .catch((e) => {
                    console.error(e);
                    // TODO: handle received error messages
                })
                .then(() => {
                    app.store.dispatch(app.actions.ui.free());
                    if (this.state.mounted) {
                        this.setState({ busy: false });
                    }
                });
        }
    }
    /**
     * Calls API to submit question
     * Overload this on edit question to call the other api endpoint
     * @return {Promise}
     */
    submitQuestion(question, anonymous, categoryId, attachments) {
        return app.api.questions.postQuestion(this.props.eventId, question, anonymous, categoryId, attachments);
    }
}

const EventQuestsPostQuestionConnected = connectQuests(EventQuestsPostQuestion);

export default (props) => {
    const { eventId, qcatId } = props.match.params,
        event = useEvent(eventId),
        { default_question_category } = event,
        category = qcatId == 'all' || !qcatId ? default_question_category : event.question_categories.find((cat) => cat.id == qcatId),
        availableCategories = event.question_categories.filter(isQuestionCategoryPostable);

    if (!category || !isQuestionCategoryPostable(category)) {
        const category = availableCategories[0];
        if (!category) return <RelativeRedirect to=".." />;

        const nextPath = generatePath(props.match.path, { ...props.match.params, qcatId: category.id });
        return <Redirect to={nextPath} />;
    }

    return <EventQuestsPostQuestionConnected {...props.match.params} />;
};
